import { unsetState } from '~src/state';

const dynamicModes = [
  'afSelectPhotoActive',
  'magicFrameSelectPersonPhotoActive',
  'magicFrameSelectBackgroundPhotoActive',
  'magicFrameSelectFramePhotoActive',
];

export const resetAllDynamicModes = () => {
  dynamicModes.forEach((dynamicMode) => {
    unsetState(dynamicMode);
  });
};
